
/**
 * ダッシュボードページ
 * 認証済みユーザー専用のメインページ
 */

import React from 'react'
import { DashboardContent } from '@/shared/components/DashboardContent'

/**
 * ダッシュボードページコンポーネント
 * AuthGuardによって保護されており、未認証ユーザーはログインページにリダイレクトされる
 */
export default function DashboardPage() {
  return <DashboardContent />
}